// 罐箱服务
export const TankServiceZh = {
  // 中文
  Tank:	'罐箱',
  Tankservice: '罐箱服务',
  DataStatistics: '数据统计',
  OrderInquiry: '订单查询',
  BusinessType: '业务类型',
  Foreigntrade: '外贸',
  Domestictrade: '内贸',
  Yard: '堆场',
  CurrentMonth: '当月度',
  CurrentQuarter: '当季度',
  CurrentYear: '当年度',
  Pendingentry: '待进场',
  Attheyard: '在堆场',
  Pendingexit: '待出场',
  Exit: '已出场',
  Businessquantity: '业务数量',
  TankBusinessquantity:	'业务数量',
  Tickets: '(票)',
  Tankvolume: '箱量',
  volume: '体积',
  Boarding: '上船',
  Arrival: '到港',
  ExchangeDO: '换单',
  Returntank: '还罐',
  Businessstatistics: '业务统计',
  Tankboxticket: '罐箱(票)',
  TheFarEast: '远东',
  China: '中国',
  Statisticsoftankvolume: '箱量统计',
  TankvolumeCount: '罐箱(箱量)',
  TypeCount: '箱型箱量',
  Ordernumber: '我司编码',
  CustomerNumber: '客户编码',
  Orderinterval: '下单区间',
  Ordertime: '下单时间',
  OrderTimes: '下单时间',
  Pleaseenterthecontent: '请输入内容',
  MasterHouseBillofLading: '主/分单号',
  Portofdeparture: '起运港',
  Portofdischarge: '目的港',
  ProductName: '品名',
  Whethertosubscribe: '是否订阅',
  Inquiry: '查询',
  Reset: '重置',
  Export: '导出',
  DetailedView: '明细查看',
  SerialNumber: '序号',
  Billofladingnumber: '提货单号',
  OrderStatus: '订单状态',
  Deliveryplace: '送货地',
  Operation: '操作',
  Subscription: '订阅',
  Subscribed: '已订阅',
  DownloadAttachment: '下载附件',
  Download: '下载',
  SubscriptionCenter: '订阅中心',
  PortofDepartureInformation: '起运港信息',
  DestinationPortInformation: '目的港信息',
  Deliveryaddressinformation: '送货地址信息',
  Grossweight: '毛重',
  Volume: '体积',
  TankYardvolume:	'箱量',
  Singleticketsubscription: '单票订阅',
  SubscriptionTheme: '订阅主题',
  Receivingemailaccount: '接收邮箱账号',
  CCemailaccount: '抄送邮箱账号',
  Save: '保存',
  Cancel: '取消',
  Submit: 'Save',
  FileName: '文件名',
  FileType: '文件类型',
  Tanknumber: '罐号',
  ContainerNo: '罐号',
  Actualloading: '实际装货',
  Servicerequest: '服务请求',
  Actualunloading: '实际卸货',
  Loadingfactory: '装货工厂',
  Loadingaddress: '装货地址',
  Unloadingfactory: '卸货工厂',
  Unloadingaddress: '卸货地址',
  Actualloadingdate: '实际装货日期',
  Actualunloadingdate: '实际卸货日期',
  Plannumber: '计划单号',
  Timeenteringtheyard: '进场时间',
  Timeoutoftheyard: '出场时间',
  Statusenteringtheyard: '进场状态',
  Tankstatus: '罐状态',
  Yardaddress: '堆场地址',
  Loading: '装货',
  Unloading: '卸货',
  Wannasubscribe: '我要订阅',
  Subscriptionhistory: '历史订阅',
  PleaseSelect: '请选择',
  TankYard: '罐箱堆场',
  TankForeigntrade: '罐箱外贸',
  TankDomestictrade: '罐箱内贸',
  EntryPlannumber: '进场计划单号',
  GateOutPlannumber: '出场计划单号',
  PlanningEntryTime: '计划进场时间',
  PlanningGateOutTime: '计划出场时间',
  ActualGateInTime: '实际进场时间',
  ActualGateOutTime: '实际出场时间',
  Creator: '创建人',
  CreateTime: '创建时间',
  Modifier: '修改人',
  ModificationTime: '修改时间',
  OtherInformation: '其他信息',
  GateOutPlan: '出场计划单',
  GateOutInformation: '出场信息',
  EntryPlan: '进场计划单',
  EntryInformation: '进场信息',
  PutItAway: '收起',
  SwitchtoListMode: '切换为列表模式',
  SwitchtoCardMode: '切换为卡片模式',
  StartDT: '开始日期',
  EndDT: '结束日期',
  To: '~',
  LoadingInformation: '装货信息',
  UnloadingInformation: '卸货信息',
  SubscriptionInformation: '订阅信息',
  OrderReceived: '接单',
  Delivery: '送货',
  Returnbox: '还箱',
  DeliveryDT: '送货日期',
  JobNo: '我司编码',
  Loaded: '已装货',
  Sailed: '已开航',
  ArrivedatPort: '已到港',
  Discharged: '已卸货',
  GateIn: '进场',
  GateOut: '出场',
  InDepot: '已进场',
  All: '全部',
  YES: '是',
  NO: '否',
  Multimodal: '多式联运',
  RoadTransport: '公路运输',
  EmptyClean: '空罐',
  EmptyDirty: '空残',
  TankContainer: '罐箱',
  Others: '其他',
  TankvolumeOthers: '箱量其他',
  Content1: '免责声明：尊敬的客户，本页面显示的业务相关数据信息，因存在业务量动态变化以及信息更新滞后等情况，仅供参考，无法律约束力。最终信息，以双方书面确认为准，感谢理解与配合。',
  Content2: '外贸',
  Content3: '内贸',
  Content4: '堆场',
  Content5: '查询失败',
  Content6: '多邮箱用逗号分隔,',
  Content7: '提交成功',
  Content8: 'Milestone节点',
  Content9: '请输入订阅主题',
  Content10: '请输入接收邮件账号',
  Content11: '请选择Milestone节点!',
  Content12: '客户罐群管理',
  CFSAttachments: '图片预览',
  SelectAll: '全选',
  DeselectAll: '取消全选',
  BatchDownload: '批量下载',
  Close: '关闭',
  ImageLoading: '图片加载中…',
  Check: '勾选',
  Preview: '预览',
  CanTracking: '罐跟踪',
  DistributionKanban: '罐分布看板',
  CanGroupList: '罐群列表',
  TankDetailsTracking: '罐明细跟踪',
  AvailableOrNot: '是否可用',
  Unused: '未使用',
  Used: '已使用',
  RentedOut: '已退租',
  TankSize: '罐容量',
  CustomerNo: '客户编号',
  ApplicationHirePeriod: '实际起租日期',
  EstimateHirePeriod: '合同起租日期',
  ContractRefundDate: '合同退租日期',
  ActualRetirementDate: '实际退租日期',
  LastTestDate: '当前年检日期',
  LastTestType: '当前年检类型',
  NextTestDate: '下次年检日期',
  DaysUntilInspection: '距离下次年检剩余天数',
  MaterialNameC: '中文品名',
  MaterialNameE: '英文品名',
  TerminationDate: '退租日期',
  BusinessStatus: '来回程状态',
  Vessel: '船名',
  Quantity: '数量',
  CreateOrder: '创建订单时间',
  CreateDTDiff: '接单至实际开船(天)',
  Package: '包装形式',
  Customer_No: '客户编码',
  GCW: '毛重(KG)',
  NCW: '净重(KG)',
  DangJobNo: '当前业务',
  CurrentAddress: 'GPS当前位置',
  BackEmptyReturnDate: '实际空返堆场时间',
  EstimatedBackEmptyReturnDate: '预计空返堆场时间',
  BackATA: '回程实际到达',
  BackETA: '回程预计到达',
  BackATD: '回程实际出发',
  BackETD: '回程预计出发',
  BackVoyge: '回程航次',
  BackVessel: '回程船名',
  BackMBL_NO: '回程提单号',
  BackCarrier_Name: '回程船公司',
  BackEmptyPickUpDate: '空罐出堆场时间',
  BackPOL_Name: '回程起运港',
  BackBooking_No: '回程业务编号',
  EmptyReturnDate: '空罐入堆场时间',
  ATAWeek: '实际到达(周)',
  ETAWeek: '预计到达(周)',
  ATA: '去程实际到达',
  ETA: '去程预计到达',
  ATD: '去程实际出发',
  ETD: '去程预计出发',
  SailingDays: '航程',
  MBL_NO: '提单号',
  Carrier_Name: '去程船公司',
  Voyge: '航次',
  LoadingDate: '装货时间',
  TotalRoundTripTime: '来回程时间(天)',
  EmptyTankAtPODDepot: '空罐目的港等待(天)',
  TankAtConsigneeSite: '收货人用箱(天)',
  LadenWaitingDays: '重罐目的港等待(天)',
  LoadingDateDiff: '装货至开船(天)',
  RenewalDate: '续租日期',
  RenewalDay: '合同续租时长(天)',
  LogisticsStatus: '物流状态',
  ContainerType: '罐箱尺寸',
  Goods_EN: '货物品名',
  Content13: '重罐到始发港日期',
  Content14: '重箱出口船期',
  Content15: '重箱到港日期',
  Content16: '清关日期',
  Content17: '目的港提货时间',
  Content18: '目的港还罐日期',
  Content19: '空罐返回船期ETD',
  Content20: '业务编号',
  Content21: '目的国客户',
  TankReturnDetails: '回程跟踪',


  DYProperty1: '罐号',
  DYProperty2: '离下次年检天数',
  DYProperty3: '离开目的港',
  DYProperty4: '目的港重罐停留天数',
  DYProperty5: '目的港重罐堆存天数',
  DYProperty6: '收货工厂停留天数',
  DYProperty7: '目的港空罐堆存天数',
  DYProperty8: '目的港空罐停留天数',
  DYProperty9: '目的港停留总天数',
  DYProperty10: 'ATA',
  DYProperty11: '目的港提货时间',
  DYProperty12: '重罐堆场',
  DYProperty13: '重罐进堆场',
  DYProperty14: '重罐出堆场',
  DYProperty15: '工厂地址',
  DYProperty16: '进工厂时间',
  DYProperty17: '出工厂时间',
  DYProperty18: '空罐堆场',
  DYProperty19: '空罐进堆场',
  DYProperty20: '空罐出堆场',
  DYProperty21: '空罐进港口',
  DYProperty22: '空罐出港口',
  DYProperty23: '船期',
  DYProperty24: '预计到港时间',
  DYProperty25: '回堆场时间',
  DYProperty26: '离开目的港地址',
  DYProperty27: '是否回程',

}

export const TankServiceEn = {
  // 英文
  Tank:	'Tank',
  Tankservice:	'Tank Service',
  DataStatistics:	'Dashboard',
  OrderInquiry:	'Tracking',
  BusinessType:	'Category',
  Foreigntrade:	'International Transport',
  Domestictrade:	'Domestic Transport',
  Yard:	'Yard Service',
  CurrentMonth:	'Current Month',
  CurrentQuarter:	'Current Quarter',
  CurrentYear:	'Current Year',
  Pendingentry:	'Pending In',
  Attheyard:	'In Yard',
  Pendingexit:	'Pending Out',
  Exit:	'Released',
  Businessquantity:	'Quantity',
  TankBusinessquantity:	'Orders',
  Tickets:	'(Orders)',
  Tankvolume:	'Volume',
  TankvolumeCount:	'Volume',
  TypeCount: 'Type & Amt',
  volume:	'Volume',
  Boarding:	'Boarding',
  Arrival:	'Arrival',
  ExchangeDO:	'Exchange D/O',
  Returntank:	'Tank Return',
  Businessstatistics:	'Order Statistics',
  Tankboxticket:	'Orders',
  TheFarEast:	'Far East',
  China:	'China',
  Statisticsoftankvolume:	'Volume Stasistics',
  Ordernumber:	'MW No.',
  CustomerNumber:	'Your Ref No.',
  Orderinterval:	'Booking Date',
  Ordertime:	'Booking Date',
  OrderTimes: 'Booking Date',
  Pleaseenterthecontent:	'Please Enter The Content',
  MasterHouseBillofLading:	'M/HBL No.',
  Portofdeparture:	'POL',
  Portofdischarge:	'POD',
  ProductName:	'Goods',
  Whethertosubscribe:	'Subscribe',
  Inquiry:	'Search',
  Reset:	'Reset',
  Export:	'Export',
  DetailedView:	'Details',
  SerialNumber:	'No',
  Billofladingnumber:	'MBL NO.',
  OrderStatus:	'Order Status',
  Deliveryplace:	'Delivery Place',
  Operation:	'Operation',
  Subscription:	'Subscription',
  Subscribed:	'Subscribed',
  DownloadAttachment:	'Download',
  Download:	'Download',
  SubscriptionCenter:	'Subscription',
  PortofDepartureInformation:	'Port Of Loading',
  DestinationPortInformation:	'Port Of Destination',
  Deliveryaddressinformation:	'Delivery Address',
  Grossweight:	'G.WT',
  Volume:	'VOL',
  TankYardvolume:	'TEU',
  Singleticketsubscription:	'Single Order Subscribe',
  SubscriptionTheme:	'Subject',
  Receivingemailaccount:	'To',
  CCemailaccount:	'Cc',
  Save:	'Save',
  Cancel:	'Cancel',
  Submit: 'Save',
  FileName:	'File Name',
  FileType:	'File Type',
  Tanknumber:	'Tank No.',
  ContainerNo:	'Tank No.',
  Actualloading:	'Loading',
  Servicerequest:	'Service Request',
  Actualunloading:	'Unloading',
  Loadingfactory:	'Pickup',
  Loadingaddress:	'Address',
  Unloadingfactory:	'Delivery',
  Unloadingaddress: 'Address',
  Actualloadingdate:	'Actual Loading Date',
  Actualunloadingdate:	'Actual Unloading Date',
  Plannumber:	'Planned Order',
  Timeenteringtheyard:	'In Date',
  Timeoutoftheyard:	'Out Date',
  Statusenteringtheyard:	'Status',
  Tankstatus:	'Tank Status',
  Yardaddress:	'Yard Address',
  Loading:	'Loading',
  Unloading:	'Unloading',
  Wannasubscribe:	'Subscribe',
  Subscriptionhistory:	'Subscription History',
  PleaseSelect: 'Please Select',
  TankYard: 'Container Yard',
  EntryPlannumber: 'Plan In Number',
  GateOutPlannumber: 'Plan Out Number',
  PlanningEntryTime: 'Plan In Date',
  PlanningGateOutTime: 'Plan Out Date',
  ActualGateInTime: 'Actual In Date',
  ActualGateOutTime: 'Actual Out Date',
  Creator: 'Creator',
  CreateTime: 'Creation Time',
  Modifier: 'Modifier',
  ModificationTime: 'Modification Time',
  OtherInformation: 'Other Information',
  GateOutPlan: 'Gate Out Plan',
  GateOutInformation: 'Exit Information',
  EntryPlan: 'Plan Enter Number',
  EntryInformation: 'Enter Information',
  PutItAway: 'Collapse',
  SwitchtoListMode: 'Switch to List Mode',
  SwitchtoCardMode: 'Switch to Card Mode',
  TankForeigntrade: 'International Transport',
  TankDomestictrade: 'Domestic Transport',
  StartDT: 'Start Date',
  EndDT: 'End Date',
  To: '~',
  LoadingInformation: 'Loading Information',
  UnloadingInformation: 'Unloading Information',
  SubscriptionInformation: 'Subscription Information',
  OrderReceived: 'Order Received',
  Delivery: 'Delivery',
  Returnbox: 'Return Date',
  DeliveryDT: 'Delivery Date',
  JobNo: 'Job No.',
  Loaded: 'Loading',
  Sailed: 'Sailed',
  ArrivedatPort: 'Arrived at Port',
  Discharged: 'Unloading',
  GateIn: 'Gate In',
  GateOut: 'Gate Out',
  InDepot: 'In Yard',
  All: 'All',
  YES: 'Yes',
  NO: 'No',
  Multimodal: 'Multimodal Transportation',
  RoadTransport: 'Road Transportation',
  EmptyClean: 'Empty Clean',
  EmptyDirty: 'Empty Dirty',
  TankContainer: 'Tank Container',
  Others: 'Others',
  TankvolumeOthers: 'Tankvolume Others',
  Content1: 'Disclaimer:  The relevant information displayed on this page is for your reference only. The final information is subject to written confirmation by both parties.',
  Content2: 'International Transport',
  Content3: 'Domestic Transport',
  Content4: 'Yard Service',
  Content5: 'Query failed',
  Content6: 'Multiple email addresses separated by commas',
  Content7: 'Submitted successfully',
  Content8: 'Tick To Subscribe',
  Content9: 'Please enter the Subscription subject',
  Content10: 'Please enter the Receiver email address',
  Content11: 'Please select the Subscribe Node!',
  Content12: 'Tank Fleet Management',
  CFSAttachments: 'Preview',
  SelectAll: 'Select All',
  DeselectAll: 'Deselect All',
  BatchDownload: 'Batch Download',
  Close: 'Close',
  ImageLoading: 'Image Loading…',
  Check: 'Check',
  Preview: 'Preview',
  CanTracking: 'Tank Tracking',
  DistributionKanban: 'Distribution Kanban',
  CanGroupList: 'Can Group List',
  TankDetailsTracking: 'Tank Details Tracking',
  AvailableOrNot: 'Status',
  Unused: 'Unused',
  Used: 'Used',
  RentedOut: 'RentedOut',
  TankSize: 'Tank Size',
  CustomerNo: 'Shipper Ref',
  ApplicationHirePeriod: 'Actual On-Hire Date',
  EstimateHirePeriod: 'Contract Rent Date',
  ContractRefundDate: 'Contract Refund Date',
  ActualRetirementDate: 'Actual Retirement Date',
  LastTestDate: 'Last Test Date',
  LastTestType: 'Last Test Type',
  NextTestDate: 'Next Test Date',
  DaysUntilInspection: 'Days Until Inspection',
  MaterialNameC: 'Last Cargo(Chinese)',
  MaterialNameE: 'Last Cargo(English)',
  TerminationDate: 'Return Date',
  BusinessStatus: 'Status',
  Vessel: 'Vessel',
  Quantity: 'Quantity',
  CreateOrder: 'Date of delivery order',
  CreateDTDiff: 'Receive order to ATD',
  Package: 'Package (Tank/IBC)',
  Customer_No: 'PO',
  GCW: 'G Weight (KG)',
  NCW: 'N Weight (KG)',
  DangJobNo: 'MW No.',
  CurrentAddress: 'GPS Current Address',
  BackEmptyReturnDate: 'Actual empty back CHINA depot',
  EstimatedBackEmptyReturnDate: 'Estimated empty back to CHINA depot',
  BackATA: 'Backhaul ATA',
  BackETA: 'Backhaul ETA',
  BackATD: 'Backhaul ATD',
  BackETD: 'Backhaul ETD',
  BackVoyge: 'Backhaul Voyage No.',
  BackVessel: 'Backhaul Vessel name',
  BackMBL_NO: 'Backhaul MBL',
  BackCarrier_Name: 'Backhaul carrier',
  BackEmptyPickUpDate: 'Date of empty tank depot out',
  BackPOL_Name: 'Backhaul Port of loading',
  BackBooking_No: 'Backhaul Forwarder’s Reference',
  EmptyReturnDate: 'Date of empty tank depot in',
  ATAWeek: 'ATA Week',
  ETAWeek: 'ETA Week',
  ATA: 'Headhaul ATA',
  ETA: 'Headhaul ETA',
  ATD: 'Headhaul ATD',
  ETD: 'Headhaul ETD',
  SailingDays: 'SailingDays',
  MBL_NO: 'MBL',
  Carrier_Name: 'Headhaul carrier',
  Voyge: 'Voyge',
  LoadingDate: 'Date of cargo loading',
  TotalRoundTripTime: 'Total Round Trip Time',
  EmptyTankAtPODDepot: 'Empty Tank @POD Depot',
  TankAtConsigneeSite: 'Consignee Site',
  LadenWaitingDays: 'Laden waiting @POD',
  LoadingDateDiff: 'Export Processing Time',
  RenewalDate: 'Renewal Date',
  RenewalDay: 'Renewal Day(Day)',
  LogisticsStatus: 'Logistics Status',
  ContainerType: 'Container Type',
  Goods_EN: 'DESCRIPTION',
  Content13: 'POL GATE IN DATE',
  Content14: 'ATD',
  Content15: 'ATA',
  Content16: 'FINISH CUSTOMS CLEARANCE DATE',
  Content17: 'PICK UP DATE(DEST)',
  Content18: 'GATE IN DATE(DEST)',
  Content19: 'EMPTY TANK RETURN SCHEDULE ETD',
  Content20: 'JOB NO',
  Content21: 'Destination Country Customer',
  TankReturnDetails: 'Tank Backhaul Tracking',
  DYProperty1: 'TankNo',
  DYProperty2: 'Inspection',
  DYProperty3: 'PodName',
  DYProperty4: 'Laden waiting @ POD',
  DYProperty5: 'Laden @ POD depot',
  DYProperty6: 'Waiting @ Cnee site',
  DYProperty7: 'Empty @ POD depot',
  DYProperty8: 'Empty @ POD port',
  DYProperty9: 'Total days @ POD',
  DYProperty10: 'ATA',
  DYProperty11: 'Pick Up',
  DYProperty12: 'Depot Address',
  DYProperty13: 'Laden Depot In',
  DYProperty14: 'Laden Depot Out',
  DYProperty15: 'Factory Address',
  DYProperty16: 'CNEE in',
  DYProperty17: 'CNEE out',
  DYProperty18: 'Residual Address',
  DYProperty19: 'Empty Depot In',
  DYProperty20: 'Empty Depot Out',
  DYProperty21: 'Gate In',
  DYProperty22: 'Gate Out',
  DYProperty23: 'Backhaul TT',
  DYProperty24: 'Backhaul ETA',
  DYProperty25: 'Ready to use',
  DYProperty26: 'Departure port address',
  DYProperty27: 'Backhaul',
}
